import { DataFieldWithDataType } from '../../../common-types';
import {
  MetricCategoryId,
  MetricFormatTypeId,
  MetricGroupId,
  MetricId,
  MetricType,
} from '../graphql/generated/graphql-sdk';

// We use this for raw html strings. The content should be parsed as (safe) HTML and then presented in that way.
export type HtmlString = string;

export enum MetricLifecycleStageEnum {
  MetricLifecycleStageActive = 'MetricLifecycleStageActive',
  MetricLifecycleStageDeprecated = 'MetricLifecycleStageDeprecated',
  MetricLifecycleStageDevelopment = 'MetricLifecycleStageDevelopment',
  MetricLifecycleStageDisabled = 'MetricLifecycleStageDisabled',
}

export interface MetricDetails {
  id: MetricId;
  metricGroupId: MetricGroupId;
  metricType: MetricType;
  formatType: MetricFormatTypeId;
  underlyingFields: DataFieldWithDataType[] | null;
  defaultPosition: number;
  segmentationPercAllowed: boolean;
  lifecycleStage: MetricLifecycleStageEnum | undefined;
  tooltipJapanese: HtmlString | null;
  tooltipEnglish: HtmlString | null;
}

export interface MetricGroupDetails {
  id: MetricGroupId;
  defaultCategory: MetricCategoryId;
  dimensions: MetricDetails[];
  defaultPosition: number;
  defaultCategoryPosition: number;
}

export interface MetricCategoryDetails {
  id: MetricCategoryId;
  defaultPosition: number;
}
